const ENV = import.meta.env.VITE_ENV_NAME
export const getOptimizedUrl = (url?: string, width?: number): string | undefined => {
  if (!url) return undefined

  if (url.includes('firebasestorage.googleapis.com')) {
    const finalWidth = width || 720
    let host = ''
    switch (ENV) {
      case 'prod':
        host = 'images.51trips.com'
        break
      case 'uat':
        host = 'images.uat.51trips.com'
        break
      case 'dev':
        host = 'images.dev.51trips.com'
        break
      default:
        host = 'images.51trips.com'
    }
    return url.replace(
      `https://firebasestorage.googleapis.com/v0/b/tripsapp-${ENV}.appspot.com/o/`,
      `https://${host}/insecure/rs:fit:${finalWidth}:${finalWidth}/plain/assets/`
    )
  }
  return url
}
